import { BankAccount, MoneyWithdrawal, TableSorting } from '@src/types'
import { PaymentAccount } from '@src/types/PaymentAccount'
import { AxiosRequestConfig } from 'axios'
import { api, ApiRes } from './client'

export type WalletData = {
    id: string
    balance: number
    external_internal_id: number
    external_id: string
    status: number
    email: string
    full_name: string | null
    nationality: string | null
    country: string | null
    date_of_birth: string | null
    created_at: string
    updated_at: string
    natural_profile_id: string | null
    payment_account_id: string
    type: 'natural' | 'legal'
    payer_or_beneficiary: 'payer' | 'beneficiary'
    company_name: string | null
    company_description: string | null
    company_website_url: string | null
    company_identification_number: string | null
    legal_profile_id: string | null
    synced_at: string | null
    is_current: boolean
    payment_account: PaymentAccount
    profile_id: string | null
    money_withdrawals: MoneyWithdrawal
    retrievable_balance: {
        amount: number
        currency: string
    }
    can_withdraw: boolean
    can_deposit: boolean
    bank_accounts: BankAccount[]
    withdrawal_limit: {
        amount: number
        currency: string
    }
    account_id: string | null
}

export type WalletsResponse = {
    success: boolean
    wallets: WalletData[]
    wallets_count: number
}

export const getWallets = (
    filters?: object,
    page?: number,
    limit?: number,
    sorting?: TableSorting[]
): ApiRes<WalletsResponse> => {
    const config: AxiosRequestConfig = {}

    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    if (typeof page === 'number' && typeof limit === 'number') {
        config.params['range'] = page * limit - limit + '-' + page * limit
    }

    if (sorting && sorting.length) {
        config.params['sort'] = sorting
            .map((sort) => {
                return (sort.direction === 'desc' ? '-' : '') + sort.field
            })
            .join(',')
    }

    return api.get('v2/manage/wallets', config)
}

export const getWallet = (id: string): ApiRes<WalletData> => {
    return api.get('v2/manage/wallets/' + id)
}

export default { getWallets, getWallet }
